import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

export const PrivateElement = ({ element }) => {
  // const { isAuthorized } = useAuth();
  return element;
};
